/* eslint-disable no-underscore-dangle */
import TYPES from './types.js'
import _$ from 'js/api/getdata.js'
import Cookie from 'js/lib/cookie.js'

window.TYPES = TYPES

/**
 * 获取当前语言
 * @param commit
 * @param state
 */
export const getLanguage = ({ commit, state }) => {
  let language =
    Cookie.get('language') ||
    localStorage.getItem('language') ||
    (navigator.language || navigator.browserLanguage).toLowerCase().substr(0, 2)
  if (language === 'tw') {
    language = 'zh'
  }
  if (language === 'ja') {
    language = 'en'
  }
  commit(TYPES.GET_LENOVO_LANGUAGE, language)
}
/**
 * 获取zBox类型  elbe:elbe私有化 | private 私有V2021 | public elbe线上（公有）
 * version:v9.0 表示精卫9.0版本
 * @param commit
 * @param state
 */
export const getBoxType = ({ commit, state }) => {
  _$.getData('getBoxType', null, res => {
    commit(TYPES.GET_BOX_Type, res.data.boxType)
    commit(TYPES.GET_SPECIAL_VERSION, res.data.version || '')
    localStorage.setItem('boxType', res.data.boxType)
    console.log('box type:', res.data.boxType)
  })
}

/**
 * 获取zBox用户信息
 * @param commit
 * @param state
 */
export const getBoxUserInfo = ({ commit, state }) => {
  _$.getData('getBoxUserInfo', null, res => {
    localStorage.setItem('username', res.data.user_name)
    commit(TYPES.GET_BOX_USER_INFO, res.data)
  })
}
/**
 * 获取当前用户信息
 * @param commit
 * @param state
 */
export const getUserInfo = ({ commit, state }) => {
  _$.getData('getUserInfo', null, res => {
    commit(TYPES.GET_USER_INFO, res.data)
  })
}

/**
 * 获取当前账户信息
 * @param commit
 * @param state
 */
export const getAccountInfo = ({ commit, state }) => {
  _$.getData('getAccountInfo', null, res => {
    commit(TYPES.GET_LENOVO_ACCOUNT_INFO, res.data)
  })
}

/**
 * 获取当前自定义信息
 * @param commit
 * @param state
 */
export const getCustomizeInfo = ({ commit, state }) =>
  _$.getData('getCustomizeInfo', null, res => {
    commit(TYPES.GET_LENOVO_CUSTOMIZE_INFO, res.data)
  })

/**
 * 获取SESSION
 * @param commit
 * @param state
 */
export const getSession = ({ commit, state }, context) =>
  new Promise((resolve, reject) => {
    _$.getData('getSession', null, res => {
      commit(TYPES.GET_SESSION, res.data)
      resolve(res.data)
    })
  })
/**
 * 获取当前用户角色
 * @param commit
 * @param state
 */
export const getUserRole = ({ commit, state }) =>
  _$.getData('getUserRole', null).then(res => {
    commit(TYPES.GET_USER_ROLE, res.data)
  })

/**
 * @param commit
 * @param state
 */
export const getLicenseInfo = ({ commit }, params) =>
  _$.get('getLicenseInfo', params).then(res => {
    commit(TYPES.GET_LICENSE_INFO, res.data)
  })



// WEBPACK FOOTER //
// ./store/actions.js